import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-finish-step",
  "use": "icon-finish-step-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-finish-step\">\n<circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#007AF5\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.87828 10.3639L12.1211 6.12111L13.5353 7.53532L9.2925 11.7782L9.29271 11.7784L7.87849 13.1926L4.34296 9.65704L5.75717 8.24283L7.87828 10.3639Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol